<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="viewRecord"
  >
    <v-card dark class="chat-container" v-if="dialog">
      <v-btn icon fixed right top @click="dialog = false">
        <v-icon>fa-times</v-icon>
      </v-btn>
      <div class="body" ref="body" v-infinite-scroll="getRecords" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-reverse>
        <div 
          v-for="record in records"
          :key="record.id"
          :class="['message', record.sender == 'seller' ? 'b' : 'a']" 
          @click.self="$refs.reasonDialog.submit(reason => violate(record, reason, {penalty: penalty}))"
        >
          <div class="text" v-if="record.type == 'text'">
            {{ record.text }}
          </div>
          <div class="gift" v-else-if="record.type == 'gift'">
            送出一個
            <img 
              v-once
              :src="$HOST_URL + record.gift.image_path"
            ></img>
          </div>
          <img 
            v-else-if="record.type == 'image'"
            v-once
            :src="$HOST_URL + record.image_path"
            @click="overlay = {active: true, src: $HOST_URL + record.image_path, transition: false}"
          ></img>
          <audio 
            v-else-if="record.type == 'audio'"
            :src="$HOST_URL + record.audio_path" 
            controls 
            controlsList="nodownload noplaybackrate"
          ></audio>
          <v-responsive 
            v-else-if="record.type == 'video'"
            :width="$vuetify.breakpoint.xsOnly ? 300 : 400"
            :max-width="$vuetify.breakpoint.xsOnly ? 300 : 400" 
            :max-height="$vuetify.breakpoint.xsOnly ? 200 : 300"
          >
            <video-player
              class="video-player vjs-big-play-centered" 
              v-once
              :playsinline="true" 
              :options="$func.videoOption({
                src: $HOST_URL + record.video_path,
                bigPlayButton: true,
                autoplay: false,
                loop: false,
                controls: true,
              })"></video-player>
          </v-responsive>
          <v-card 
            v-else-if="record.type == 'product'"
            class="story-item" 
            flat 
            @click="$root.$emit('story', chatroom.seller, record.product, record.product.product_type)"
          >
            <v-img
              :src="$func.productImagePreview(record.product)"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.4)"
              width="150px"
              aspect-ratio="0.75"
              class="align-end"
            >
              <div class="description" :title="record.product.title">{{ record.product.title }}</div>
            </v-img>
          </v-card>
          <span class="created_at" v-if="$func.dayDiff(record.created_at) === 0">
            今天 {{ record.created_at | time }}
          </span>
          <span class="created_at" v-else-if="$func.dayDiff(record.created_at) === 1">
            昨天 {{ record.created_at | time }}
          </span>
          <span class="created_at" v-else-if="$func.isThisYear(record.created_at)">
            {{ record.created_at | dateTime }}
          </span>
          <span class="created_at" v-else>{{ record.created_at | dateTime }}</span>
        </div>
      </div>
    </v-card>
    <ReasonDialog ref="reasonDialog">
      <template v-slot:default>
        <v-text-field label="扣除桃子" :rules="[$rules.integer]" v-model="penalty"></v-text-field>
      </template>
    </ReasonDialog>
  </v-dialog>
</template>

<script>
import ReasonDialog from '@/components/ReasonDialog'
export default {
  props: ['chatroom'],
  components: { ReasonDialog },
  data() {
    return {
      dialog: false,
      busy: false,
      page: 1,
      records: [],
      penalty: ''
    }
  },
  watch: {
    dialog(newValue) {
      if(!newValue) {
        Object.assign(this.$data, this.$options.data.apply(this))
        this.$refs.body.style.visibility = 'hidden'
      }
    }
  },
  methods: {
    open(chatroom) {
      this.$root.$emit('loading', true)
      this.chatroom = chatroom
      this.dialog = true
      // this.busy = false
    },
    getRecords() {
      if(!this.chatroom) {
        return
      }
      // this.busy = true
      return this.axios(`/admin/chat/${this.chatroom.id}/message?page=${this.page}&size=50`).then(async response => {
        this.records.unshift(...response.data.data.reverse())
        if(this.page == 1) {
          await this.scrollToBottom(true)
          this.$root.$emit('loading', false)
        }
        else {
          await this.adjustScrollTop(this.$refs.body.scrollHeight, this.$refs.body.scrollTop)
        }
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
    violate(record, reason, data) {
      let payload = {
        reason: reason,
        message_id: record.id,
        penalty: data.penalty
      }
      payload[`${record.sender}_id`] = record.sender_id
      this.axios.post('/admin/violation', payload).then(response => {
        this.$root.$emit('alert', 'success', '新增成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '新增失敗')
      })
    },
    scrollToBottom(first = false) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          if(first) {
            Promise.all(
              [...this.$refs.body.getElementsByTagName('img')]
              .map(async img => {
                return new Promise(resolve => { 
                  let interval = setInterval(() => {
                    if(img.naturalWidth > 0 && img.naturalHeight > 0) {
                      clearInterval(interval)
                      resolve()
                    }
                  }, 100)
                })
              })
            )
            .then(() => {
              this.$refs.body.scrollTop = this.$refs.body.scrollHeight
              this.$refs.body.style.visibility = 'visible'
              resolve()
            })
          }
          else {
            this.$refs.body.scrollTop = this.$refs.body.scrollHeight
            resolve()
          }
        })
      })
    },
    // prevent auto scroll when prepend records
    adjustScrollTop(prev_height, prev_top) {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          this.$refs.body.scrollTop = this.$refs.body.scrollHeight - (prev_height - prev_top)
          resolve()
        })
      })
    },
  }
}
</script>

<style lang="scss">
.viewRecord {
  .chat-container {
    height: 100vh;
    max-height: 100vh;
    .message {
      &:hover {
        @extend .pointer;
        background: $grey-2;
      }
    }
  }
}
</style>